import React, { useContext } from 'react';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData'



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="about" id="about" style={{backgroundColor: theme.secondary}}>
            <div className="line-styling">
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-line" style={{backgroundColor: theme.primary}}></div>
            </div>
            <div className="about-body">
                <div className="about-description">
                    <h2 style={{color: theme.primary}}>{aboutData.title}</h2>
                    <p style={{color:theme.tertiary80}}>
                    {aboutData.description.map(desc => ( 
                       <h4 className="about-desc" style={{color:'#de00ac'}} >{desc.desc}</h4>
                    ))}
                    </p>
                </div>
                <div className="about-img">
                    <img 
                        src={aboutData.image}  
                        alt="" 
                    />
                </div>
            </div>
        </div>

    )
}

export default About
